export default __webpack_public_path__ + "static/media/Tu.2826ca04.jpg";